import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '@/components';
import { getTableColumns } from './getTableColumns';
import { BookingInfo } from '../types';
import { tableFilters } from './tableFilters';

type ContainerListTableProps = {
  data?: BookingInfo[];
  isLoading?: boolean;
};

const ContainerListTable: FC<ContainerListTableProps> = ({
  data,
  isLoading,
}) => {
  const { t } = useTranslation('searchByBooking');

  const tableColumns = getTableColumns(data, t);

  return (
    <Table
      columns={tableColumns}
      data={data}
      isLoading={isLoading}
      filters={tableFilters}
      filterDisplay="menu"
      paginator
    />
  );
};

export default ContainerListTable;
